import {Container} from '@chakra-ui/react';

import {FooterProps} from '@/models/props/NavigationFooterProps';

import {FooterNavigation} from './FooterNavigation';
import {SocialMedia} from './SocialMedia';

export const Footer = (props: FooterProps) => {
    const { menu } = props;

    return (
        <Container as="footer" maxW="full" backgroundColor="grey.100" className="page-footer">
            <Container maxW="7xl" py="7" justifyContent="center">
                <FooterNavigation menu={menu} />
                <SocialMedia />
            </Container>
        </Container>
    );
};
